import { checkRadiosSelection } from "../../../src/js/form/validation-helpers";

function chatbotCalcFormSlides() {
  const form = document.querySelector(".js-chatbot_calc_form");
  const prevSlideBtn = document.querySelector(".js-chatbot_calc_prev");
  const nextSlideBtn = document.querySelector(".js-chatbot_calc_next");
  const submitBtn = document.querySelector(".js-chatbot_calc_submit");
  let paginationItems = null;

  if (!form) {
    return;
  }

  const slides = form.querySelectorAll(".js-chatbot_calc_slide");
  let slideIndex = 0;

  // Generate pagination
  generatePagination();

  // Add event handlers for prev/next slides functionality
  prevSlideBtn.addEventListener("click", () => {
    changeSlide(slideIndex - 1);
  });

  nextSlideBtn.addEventListener("click", () => {
    changeSlide(slideIndex + 1);
  });

  // Block submit until the last slide's required radios are selected
  submitBtn.addEventListener("click", (event) => {
    const lastSlide = slides[slides.length - 1];
    const isRequiredFields = lastSlide.dataset.required || false;

    if (isRequiredFields && !checkRadiosSelection(lastSlide)) {
      event.preventDefault();
      toggleSlideErrorVisibility(true);
    }
  });

  // Event delegation for slides error hiding
  form.addEventListener("change", function (event) {
    const eventTarget = event.target;

    if (!eventTarget) {
      return;
    }

    if (eventTarget.matches(".b-radio-input")) {
      toggleSlideErrorVisibility(false);
    }
  });

  form.addEventListener("reset", (event) => {
    paginationItems.forEach((paginationItem, index) => {
      index !== 0 && paginationItem.classList.remove("m-active");
    });

    changeSlide(0);
  });

  // show/hide slide error
  function toggleSlideErrorVisibility(isVisible) {
    const inputError = form.querySelector(".js-chatbot_calc_error");

    if (inputError) {
      inputError.classList.toggle("m-shown", isVisible);
    }
  }

  // check if selected any radios of current slide in case if it's required
  function checkSlideRadiosSelection(index) {
    const currentSlide = slides[slideIndex];
    let isProceedNextSlide = true;

    if (slideIndex < index) {
      const isRequiredFields = currentSlide.dataset.required || false;

      if (isRequiredFields) {
        let isSelectedInput = checkRadiosSelection(currentSlide);

        // show error message if we don't have any radios selected
        if (!isSelectedInput) {
          isProceedNextSlide = false;
          toggleSlideErrorVisibility(true);
          return;
        }
      }
    }

    return isProceedNextSlide;
  }

  function changeSlide(index) {
    const isProceedNextSlide = checkSlideRadiosSelection(index);

    if (!isProceedNextSlide) {
      return;
    }

    // Highlight active slide pagination
    if (slideIndex < index) {
      paginationItems[index].classList.add("m-active");
    } else {
      paginationItems[slideIndex].classList.remove("m-active");
    }

    // Show/hide active slide
    slides[index].style.display = "block";
    slides[slideIndex].style.display = "none";

    slideIndex = index;

    prevSlideBtn.classList.toggle("m-disabled", index === 0);
    nextSlideBtn.classList.toggle("m-disabled", index === slides.length - 1);

    if (index === 0) {
      prevSlideBtn.classList.add("m-disabled");
    } else {
      prevSlideBtn.classList.remove("m-disabled");
    }

    if (index === slides.length - 1) {
      nextSlideBtn.classList.add("m-disabled");
      submitBtn.classList.remove("m-disabled");
    } else {
      nextSlideBtn.classList.remove("m-disabled");
      submitBtn.classList.add("m-disabled");
    }

    toggleSlideErrorVisibility(false);
  }

  function generatePagination() {
    let paginationHtml = "";
    const paginationWrapper = form.querySelector(".js-chatbot_calc_pagination");

    if (!slides.length && !paginationWrapper) {
      return;
    }

    for (let i = 0; i < slides.length; i++) {
      paginationHtml += `
      <span class="b-calculate_chatbot-pagination_item js-chatbot_calc_pagination_item ${i === 0 ? "m-active" : ""}">0${i + 1}</span>
    `;
    }

    paginationWrapper.innerHTML = paginationHtml;
    paginationItems = form.querySelectorAll(".js-chatbot_calc_pagination_item");
  }
}

export { chatbotCalcFormSlides };
